// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-panel-container .slider-wrapper{width:200px}.data-panel-container .metadata-icon{display:inline-block;margin-left:5px}.data-panel-tooltip{background-color:red}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
